import { makeCustomIcon } from './utils';

export const dimPowerIcon = makeCustomIcon(
  'Power',
  32,
  32,
  'M16 32l-7.245-8.755-8.755-7.245 8.755-7.321 7.245-8.679 7.245 8.679 8.755 7.321-8.755 7.245zM9.811 16l3.396 2.792 2.792 3.396 2.792-3.396 3.396-2.792-3.396-2.868-2.792-3.321-2.792 3.321z',
);
